import { render, staticRenderFns } from "./HTMLResponse.vue?vue&type=template&id=5def8b70&scoped=true&"
import script from "./HTMLResponse.vue?vue&type=script&lang=js&"
export * from "./HTMLResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def8b70",
  null
  
)

export default component.exports